import { slugify } from '../slugify';

export const S3_BUCKET = 'baseballnearyou';

export const TEAMS_FOLDER = 'teams';

export const USERS_FOLDER = 'users';

export const generateUserPropertyName = ({
  userId,
  propertyType,
  propertyName = new Date().toISOString(),
  dev = false,
}: {
  userId: string;
  propertyType: string;
  propertyName?: string;
  dev?: boolean;
}) => {
  return `${dev ? 'dev/' : ''}${USERS_FOLDER}/${userId}/${propertyType}/${slugify(propertyName)}`;
};

export const generateUserProfileImageName = ({
  userId,
  dev = false,
}: {
  userId: string;
  dev?: boolean;
}) => {
  return generateUserPropertyName({ userId, propertyType: 'profile', dev });
};

export const generateTeamPropertyImageName = ({
  teamName,
  propertyType,
  propertyName = new Date().toISOString(),
  dev = false,
}: {
  teamName: string;
  propertyType: string;
  propertyName?: string;
  dev?: boolean;
}) => {
  return `${dev ? 'dev/' : ''}${TEAMS_FOLDER}/${slugify(teamName)}/${propertyType}/${slugify(propertyName)}`;
};

export const generateTeamLogoName = (teamName: string, dev = false) => {
  return generateTeamPropertyImageName({
    teamName,
    propertyType: 'logo',
    dev,
  });
};
